export default "__VITE_ASSET__BPjlIndw__"